import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'>;

export function OneAttemptPaywall(props: Props) {
  return (
    <PaywallDialog.Long
      id="rooms-paywall"
      title={translate('Upgrade to Enable One Attempt')}
      actions={[
        <UIButton key="cancel" onClick={props.onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={PaywallScreens.LaunchQuizQuickQuestionOneAttempt}
        />,
      ]}
      closeLabel={translate('Close')}
      {...props}
      paywallTouch={[PaywallScreens.LaunchQuizQuickQuestionOneAttempt]}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'When One Attempt is enabled, students can only attempt the quiz once. If they are in the middle of the quiz and log out and back in, they’ll continue where they left off.'
        )}
      </p>
    </PaywallDialog.Long>
  );
}
